module.exports = __webpack_public_path__ + "static/media/S16_B.63141a26.png";